<template>
  <div class="profil-container">
    <h3 class="profil-title">Halaman Pengisian Data Vendor</h3>
    <p class="profil-subtitle">Silahkan mengisi data sesuai kolom di bawah</p>

    <!-- 1 -->
    <block-label :label="'4. PENGELOLAAN B3'" />
    <plain-label :label="'Berikan penjelasan rinci mengenai pengelolaan Bahan Berbahaya dan Beracun (B3) di perusahaan Anda'
      " />
    <input-area :storeName="'k3lStore'" :modelName="'textGrup4'" :mutationName="'k3lStore/SET_K3L_FORM'"
      :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan prosedur mengenai pengelolaan material B3 yang telah di setujui oleh manajemen dan telah di sosialisasikan kepada karyawan (Form Absensi dan Foto dokumentasi)'
      " />
    <upload-file :modelName="'prosedurB3'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :docId="12"
      :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan program mengenai pengelolaan material B3 yang telah di setujui oleh manajemen dan telah di sosialisasikan kepada karyawan'
      " />
    <upload-file :modelName="'programB3'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :docId="13"
      :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan bukti implementasi program pengelolaan material B3 (Minimal 3 Bukti dalam 1 Dokumen)'
      " />
    <upload-file :modelName="'implementasiB3'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :docId="14"
      :disabled="$store.state.k3lStore.is_sipm_approved" />
    <!-- 5 -->
    <block-label :label="'5. PENGELOLAAN LIMBAH'" />
    <plain-label :label="'Berikan penjelasan rinci mengenai pengelolaan limbah (padat, cair, dan gas) dan limbah B3 perusahaan Anda'
      " />
    <input-area :storeName="'k3lStore'" :modelName="'textGrup5'" :mutationName="'k3lStore/SET_K3L_FORM'"
      :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan prosedur pengelolaan limbah padat, cair & B3 secara umum dan khusus (pemilahan sampah, penerapan reduce, reuse & recycle) yang telah di setujui oleh manajemen'
      " />
    <upload-file :modelName="'prosedurLimbah'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :docId="15"
      :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan program pengelolaan limbah padat, cair & B3 secara umum dan khusus (pemilahan sampah, penerapan reduce, reuse & recycle) yang telah di setujui oleh manajemen'
      " />
    <upload-file :modelName="'programLimbah'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :docId="16"
      :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan bukti sosialisasi Prosedur & program pengelolaan limbah padat, cair & B3 kepada karyawan. (Form Absensi & Foto Dokumentasi Minimal 3 Bukti dalam 1 Dokumen)'
      " />
    <upload-file :modelName="'buktiPengelolaanLimbah'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :docId="17" :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan bukti implementasi Prosedur & program pengelolaan limbah padat, cair & B3 kepada karyawan. (Minimal 3 Bukti dalam 1 Dokumen, Contoh: Neraca limbah B3, laporan penyerahan limbah B3, program 3R)'
      " />
    <upload-file :modelName="'implementasiLimbah'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :docId="18" :disabled="$store.state.k3lStore.is_sipm_approved" />
    <!-- 6 -->
    <block-label :label="'6. PENCEGAHAN KECELAKAAN FATAL (GOLDEN RULES)'" />
    <div class="vendor-form-wrapper">
      <input-fill-form :label="'KEGIATAN PENCEGAHAN KECELAKAAN FATAL (GOLDEN RULES)'" :tables="[
        {
          name: 'Golden Rules',
          obj_name: 'desc',
          css: 'column100',
          input: false,
          type: '',
        },
      ]" :modelName="'addedGoldenRules'" :isRequired="false" :mutationName="'k3lStore/SET_K3L_FORM'"
        :storeName="'k3lStore'" :modalName="'modal_add_golden_rules'"
        :disabled="$store.state.k3lStore.is_sipm_approved" />
    </div>
    <plain-label :label="'Lampirkan Program Fatal Prevention yang telah di setujui oleh pimpinan perusahaan'
      " />
    <upload-file :modelName="'programFatalPrevention'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :docId="19" :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan bukti sosialisasi dan kampanye program Fatal Prevention kepada karyawan (Form Absensi & Foto Dokumentasi Minimal 3 Bukti dalam 1 Dokumen)'
      " />
    <upload-file :modelName="'sosialisasiFatalPrevention'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :docId="20" :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan bukti implementasi program kerja terkait fatal prevention tersebut (Minimal 3 Bukti dalam 1 Dokumen)'
      " />
    <upload-file :modelName="'implementasiFatalPrevention'" :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'" :docId="21" :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan dokumen kerja (prosedur, standar, form) pengaturan implementasi Fatal Prevention atau Golden Rules yang telah di setujui oleh pimpinan perusahaan'
      " />
    <upload-file :modelName="'dokumenKerjaFatalPrevention'" :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'" :docId="22" :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan bukti implementasi program Fatal Prevention & dokumen kerja (prosedur, standar, form) pengaturan implementasi Fatal Prevention atau Golden Rules (Form Absensi dan Foto Dokumentasi Minimal 3 Bukti dalam 1 Dokumen)'
      " />
    <upload-file :modelName="'implementasiDokumenKerjaFatalPrevention'" :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'" :docId="23" :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan bukti evaluasi program Fatal Prevention yang sudah berjalan'
      " />
    <upload-file :modelName="'evaluasiFatalPrevention'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :docId="24" :disabled="$store.state.k3lStore.is_sipm_approved" />

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goNext()" href="" class="btn-landing">
        Simpan dan Lanjutkan
      </div>
    </div>
  </div>
</template>

<script>
import InputArea from '../../components/forms/input/input-area.vue'
import BlockLabel from '../../components/forms/label/blockLabel.vue'
import PlainLabel from '../../components/forms/label/plainLabel.vue'
import UploadFile from '../../components/forms/input/multiple_upload.vue'
import InputFillForm from '../../components/forms/input-fill-form.vue'
export default {
  components: {
    BlockLabel,
    PlainLabel,
    InputArea,
    UploadFile,
    InputFillForm,
  },
  data() {
    return {}
  },
  methods: {
    goBack() {
      this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'grup13' })
    },
    goNext() {
      this.$store.commit('k3lStore/SAVE_DRAFT_VENDOR_INPUT', {
        onSuccess: () => {
          this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'grup78' })
        }
      })
    },
  },
}
</script>
<style scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-body {
  display: flex;
  flex-direction: column;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
